import React from 'react';
import ClientSuggestionItem from './ClientSuggestionItem';
import { clientTag } from './tag';
import ClientFacetDetails from './ClientFacetDetails';
import {
  makeCriteriaProvider,
  makeEnhancedPMCriteriaProvider
} from './enhancers';

export const EnhancedPMClientFacet = {
  makeCriteriaProvider: makeEnhancedPMCriteriaProvider,
  tag: clientTag,
  DetailsControl: (props = {}) => (
    <ClientFacetDetails
      {...props}
      usePageOfClientsAvailableForFilteringResourceUsersQuery
    />
  ),
  SuggestionItem: ClientSuggestionItem
};

export default {
  makeCriteriaProvider,
  tag: clientTag,
  DetailsControl: ClientFacetDetails,
  SuggestionItem: ClientSuggestionItem
};
